<template>
    <div>
        <div class="item_card" :class="{ 'n2_columns': !product.productImages }" v-for="(product, key) in cart"
            :key="key">

            <div class="card_column_2">
                <span class="bold_text">
                    <span v-if="isModotap()"> {{ product.quantity }}x {{ getProductLanguage(product, 'productName')
                        }}</span>
                    <span
                        :class="['checkout-line-row', { 'unavaiable': getLimits(product.productCode) }]"
                        v-else>
                        <span class="checkout-line-name">
                            {{ getProductLanguage(product, 'productName') }}
                            <span v-if="unavailableProducts[product.productCode]"
                                v-text="buildText(product.productCode)"></span>
                        </span>
                        <span class="price-col" v-if="!showprice(product, product.quantity)">{{
                            calculateItemComboPrice(product, product.quantity) }}</span>
                    </span>
                </span>

                <span class="product_desc" v-if="product.productDescription"
                    v-text="getProductLanguage(product, 'productDescription')"></span>
                <div class="observations">
                    <!-- Exibe as observações no carrinho -->
                    <div
                        :class="['product-observations', 'checkout-line-row', { 'unavaiable': getLimits(observation.obsProductCode) }]"
                        v-for="(observation, key) in product.observations" :key="key">
                        <div class="checkout-line-name">
                            <li>{{ calculateQuantity(observation, product.quantity) }}x {{ getProductLanguage(observation,
                                'obsName') }}</li>
                            <span v-if="unavailableProducts[observation.obsProductCode]"
                                v-text="buildText(observation.obsProductCode)"></span>
                        </div>
                        <span class="price-col" v-if="observation.price > 0">{{ calculateItemComboPrice(observation,
                            product.quantity) }}</span>
                    </div>
                    <!-- Exibe no carrinho os itens do combo que foram escolhidos -->
                    <div class="sub-item" v-for="(comboItem, key2) in product.productCombo" :key="key2">
                        <span :class="['checkout-line-row', { 'unavaiable': getLimits(comboItem.subItemCode) }]">
                            <span class="checkout-line-name">
                                {{ calculateQuantity(comboItem, product.quantity) }}x {{ getProductLanguage(comboItem,
                                'subItemName') }}
                                <span v-if="unavailableProducts[comboItem.subItemCode]"
                                    v-text="buildText(comboItem.subItemCode)"></span>
                            </span>
                            <span class="price-col" v-if="comboItem.price > 0">{{ calculateItemComboPrice(comboItem,
                                product.quantity) }}</span>
                        </span>
                        <div
                            :class="['sub-item-obs', 'checkout-line-row', { 'unavaiable': getLimits(comboItemObs.subItemObsProductCode) }]"
                            v-for="(comboItemObs, key3) in comboItem.observations" :key="key3">
                            <div class="checkout-line-name">
                                <li> {{ calculateQuantity(comboItemObs, product.quantity) }}x {{
                                    getProductLanguage(comboItemObs, 'subItemObsName') }} </li>
                                <span v-if="unavailableProducts[comboItemObs.subItemObsProductCode]"
                                    v-text="buildText(comboItemObs.subItemObsProductCode)"></span>
                            </div>
                            <span class="price-col" v-if="comboItemObs.price > 0">{{
                                calculateItemComboPrice(comboItemObs, product.quantity) }}</span>
                        </div>
                        <div class="c-combo-options" v-for="(choosen, key4) in getProductsComboCombo(comboItem.choosen)"
                            :key="key4">
                            <span :class="['checkout-line-row', { 'unavaiable': getLimits(choosen.subItemCode) }]">
                                <span class="checkout-line-name">
                                    {{ calculateQuantity(choosen, product.quantity) }}x {{ getProductLanguage(choosen,
                                    'subItemName') }}
                                    <span v-if="unavailableProducts[choosen.subItemCode]"
                                        v-text="buildText(choosen.subItemCode)"></span>
                                </span>
                                <span class="price-col" v-if="choosen.price > 0">{{ calculateItemComboPrice(choosen,
                                    product.quantity) }}</span>
                            </span>
                            <div
                                class="c-combo-obs checkout-line-row"
                                v-for="(ccObservations, key5) in choosen.observations" :key="key5">
                                <div class="checkout-line-name">
                                    <li>{{ calculateQuantity(ccObservations, product.quantity) }}x {{
                                        getProductLanguage(ccObservations, 'subItemObsName') }}</li>
                                    <span :class="{ 'unavaiable': getLimits(ccObservations.subItemObsProductCode) }"
                                        v-if="unavailableProducts[ccObservations.subItemObsProductCode]"
                                        v-text="buildText(choosen.subItemCode)"></span>
                                </div>
                                <span class="price-col" v-if="ccObservations.price > 0">{{
                                    calculateItemComboPrice(ccObservations, product.quantity) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card_column_3">
                <div class="price_breakdown" v-if="hasSubgroupDiscount(product)">
                    <span class="bold_text price_subtotal">{{ getString('subtotal_dois_pontos') }} {{ formatMoney(getSubtotal(product)) }}</span>
                    <span class="bold_text price_desconto">{{ getString('desconto_dois_pontos') }} -{{ formatMoney(getDiscountTotal(product)) }}</span>
                    <span class="bold_text price">{{ formatMoney(product.totalItemPrice * product.quantity) }}</span>
                </div>

                <span class="bold_text price" v-else>{{ calculateItemPrice(product) }}</span>

                <QuantityControl
                    v-if="!isModotap()"
                    :quantity="product.quantity"
                    @circleBtnRemove="decreaseQtty(key)"
                    @circleBtnAdd="increaseQtty(key)"
                    :layoutGom="true"
                    :disableControll="isModotap() || product.isABox || product.insertedByEan13 || product.productScale">
                </QuantityControl>
                <!--<div v-if="!isModotap() && !product.isABox">
                    <CircleButton v-if="!product.productScale" class="edit_button" :big="iconesGrandes" :icon="edit_white" @circleBtnClick="editProduct(product, key)"></CircleButton>
                    <CircleButton :icon="delete_white" :big="iconesGrandes" @circleBtnClick="deleteProduct(key)"></CircleButton>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import CircleButton from '@/components/CircleButton'
import QuantityControl from '@/components/QuantityControl'

import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import LocaleController from '../assets/controllers/LocaleController'

export default {
    name: 'CheckoutItemGom',
    components: {
        CircleButton,
        QuantityControl
    },
    props: ['cart', 'unavailableProducts'],
    data () {
        return {
            imgPath: require('../../static/client/powered.png'),
            edit_white: require('../../static/icons/edit_white.svg'),
            delete_white: require('../../static/icons/delete_white.svg'),
            iconesGrandes: Util.getLocalConfigs('iconesGrandes')
        }
    },
    methods: {
        formatMoney: function (value) {
            return Util.formatMoney(value)
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
        },
        isModotap: function () {
            return Util.isTapMode() || (Util.isBalancaMode() && !Util.isHybridMode())
        },
        calculateQuantity: function (product, fatherQuantity) {
            return CartController.calculateQuantity(product, fatherQuantity)
        },
        calculateItemPrice: function (product) {
            return CartController.calculateItemPrice(product)
        },
        calculateItemComboPrice: function (comboItem, fatherQuantity) {
            return CartController.calculateItemComboPrice(comboItem, fatherQuantity)
        },
        hasSubgroupDiscount: function (product) {
            return product.totalDiscountSubgroupItem > 0
        },
        getSubtotal: function (product) {
            /* pega o subtotal do itemm sem aplicar o desconto por subgrupo */
            const qty = Number(product.quantity) || 1
            let total = parseFloat(product.totalItemPrice) + parseFloat(product.totalDiscountSubgroupItem || 0)
            return parseFloat(total.toFixed(2) * qty)
        },
        getDiscountTotal: function (product) {
            return parseFloat(product.totalDiscountSubgroupItem || 0) * (product.quantity || 1)
        },
        decreaseQtty: function (key) {
            CartController.decreaseQtty(key, this)
            this.$emit('reloadPrice')
            this.$forceUpdate()
        },
        increaseQtty: function (key) {
            CartController.increaseQtty(key)
            this.$emit('reloadPrice')
            this.$forceUpdate()
        },
        editProduct: function (product, key) {
            this.$router.push({
                name: 'ProductItem',
                params: { product, key, routeBack: 'Checkout' }
            })
        },
        deleteProduct: function (key) {
            CartController.deleteProduct(key, this)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        getProductsComboCombo: function (choosen) {
            let combos = []
            if (choosen) {
                Object.keys(choosen).forEach((e) => {
                    choosen[e].forEach((c) => {
                        combos.push(c)
                    })
                })
            }
            return combos
        },
        getLimits: function (productCode) {
            if (this.unavailableProducts && this.unavailableProducts[productCode]) {
                return this.unavailableProducts[productCode].quantity > this.unavailableProducts[productCode].quantityAvailable
            }
            return false
        },
        buildText: function (productCode) {
            if (this.unavailableProducts && this.unavailableProducts[productCode]) {
                return `${this.unavailableProducts[productCode].quantity} ${this.getString('de')} ${this.unavailableProducts[productCode].quantityAvailable}`
            }
            return ''
        },
        showprice (product, fatherQuantity) {
            let itemPrice = this.calculateItemComboPrice(product, fatherQuantity)
            let totalPrice = this.calculateItemPrice(product)

            let toNumber = (v) =>
                parseFloat(String(v).replace(/[^\d,.-]/g, '').replace(',', '.')) || 0

            itemPrice = toNumber(itemPrice)
            totalPrice = toNumber(totalPrice)

            return itemPrice === 0 || Math.abs(itemPrice - totalPrice) < 0.01
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.item_card {
    background-color: @white;
    display: grid;
    grid-template-columns: auto 32%;
    padding: 1.5rem;
    border-bottom: solid 1px rgb(126, 125, 125);

    &.item_card:last-child {
        border: unset;
    }

    &.n2_columns {
        grid-template-columns: auto 30%;
    }

    .card_column_2 {
        .checkout-line-row {
            display: grid;
            grid-template-columns: minmax(0, 1fr) 90px;
            column-gap: 8px;
            align-items: start;
        }

        .checkout-line-name {
            min-width: 0;
            text-align: left;
        }

        .price-col {
            text-align: right;
            white-space: nowrap;
            justify-self: end;
            display: block;
        }

        .bold_text {
            font-size: 2rem;
            font-weight: bold;
        }

        .product_desc {
            display: block;
            margin: 10px 0;
            max-height: 150px;
            overflow: hidden auto;
            font-size: 1.2em;
        }

        .observations {
            font-size: 1.5rem;
            display: flex;
            flex-wrap: wrap;
            padding-left: 20px;

            .product-observations {
                width: 100%;

                .checkout-line-name li {
                    display: block;
                    font-weight: normal;
                    padding-bottom: 5px;
                    list-style: disc;
                }

                .checkout-line-name span {
                    display: inline;
                    padding: 0;
                    margin: 0;
                }
            }

            .sub-item {
                width: 100%;
                margin-bottom: 20px;

                > span.checkout-line-row {
                    font-weight: bold;
                    font-size: 1.4rem;
                    box-sizing: border-box;
                    padding: 0 0 5px 0;
                }

                .sub-item-obs {
                    width: 100%;
                    box-sizing: border-box;

                    .checkout-line-name li {
                        list-style: none;
                        font-size: 1.5rem;
                        margin: 0;
                        padding-bottom: 5px;
                        box-sizing: border-box;
                        min-height: 1.5rem;
                    }

                    .checkout-line-name span {
                        display: inline;
                        font-size: 1.5rem;
                        padding: 0;
                        margin: 0;
                    }
                }

                .c-combo-options {
                    padding-left: 20px;
                    padding-bottom: 3px;

                    li {
                        padding-left: 20px;
                        padding-bottom: 5px;
                    }

                    > span.checkout-line-row {
                        box-sizing: border-box;
                        padding-bottom: 3px;
                    }

                    .c-combo-obs {
                        padding-left: 20px;
                        padding-bottom: 3px;

                        .checkout-line-name li {
                            list-style: none;
                            padding-bottom: 3px;
                        }

                        .checkout-line-name span {
                            display: inline;
                            padding: 0;
                            margin: 0;
                        }
                    }
                }
            }
        }
    }

    .card_column_3 {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: start;
        align-items: end;
        margin-left: 10px;

        .edit_button {
            margin-right: 1.5rem;
        }

        .bold_text {
            font-size: 2rem;
            font-weight: bold;

            &.price {
                // margin: 0 10px 20px 10px;
                padding-bottom: 20px;
            }
        }

        div {
            display: flex;
            justify-content: center;
        }

        > div:first-child {
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-start;
        }

        .price_breakdown {
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            .price_subtotal {
                font-size: 1.5rem;
                font-weight: bold;
                padding-bottom: 4px;
            }

            .price_desconto {
                font-size: 1.5rem;
                font-weight: bold;
                color: #4caf50;
                padding-bottom: 4px;
            }
        }
    }

    .unavaiable {
        color: red;
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .item_card {
        grid-template-columns: auto 25%;

        .card_column_2 {
            .bold_text {
                font-size: 1.3rem;
            }

            .product_desc {
                font-size: 1.2rem;
            }

            .observations {
                font-size: 1.1rem;

                .sub-item {
                    > span.checkout-line-row {
                        font-size: 1.3rem !important;
                        padding: 0;
                    }

                    .sub-item-obs {
                        .checkout-line-name li {
                            font-size: 1.1rem;
                        }
                    }

                    .c-combo-options {
                        font-size: 1.3rem;

                        li {
                            font-size: 1.1rem;
                        }
                    }
                }
            }
        }

        .card_column_3 {
            min-width: 10px;

            .bold_text {
                &.price {
                    padding-bottom: 5px;
                    font-size: 20px;
                }
            }

            .price_breakdown {
                .price_subtotal {
                    font-size: 1rem;
                }

                .price_desconto {
                    font-size: 1rem;
                }
            }
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .item_card {
        grid-template-columns: auto 28%;
        padding: 10px;
        border-radius: 5px;

        .card_column_2 {
            grid-template-columns: auto auto;
            width: 100%;
            justify-content: space-between;
            border: border-box;

            .bold_text {
                font-size: 15px;

                span {
                    padding-bottom: 8px;
                }
            }

            .product_desc {
                font-size: 14px !important;
                margin: 0 !important;
            }

            .observations {
                font-size: 14px;

                .sub-item {
                    > span.checkout-line-row {
                        font-size: 14px !important;
                        padding: 0;
                    }

                    .sub-item-obs {
                        font-size: 14px;

                        .checkout-line-name li,
                        .checkout-line-name span {
                            font-size: 14px !important;
                            padding-bottom: 0;
                        }
                    }

                    .c-combo-options {
                        font-size: 14px;

                        li {
                            font-size: 14px;
                            padding: 0;
                        }
                    }
                }
            }
        }

        .card_column_3 {
            min-width: 10px;
            margin: 0 10px 20px 10px;

            .bold_text {
                &.price {
                    padding-bottom: 5px;
                    font-size: 18px;
                }
            }

            .price_breakdown {
                .price_subtotal {
                    font-size: 14px;
                }

                .price_desconto {
                    font-size: 14px;
                }
            }

            div {
                width: 90px;
            }
        }
    }
}

@media (orientation: landscape) {
    .item_card {
        grid-template-columns: auto 28%;

        .card_column_2 {
            .bold_text {
                font-size: 1.3rem;
            }

            .product_desc {
                font-size: 1.2rem;
            }

            .observations {
                font-size: 1.1rem;

                .sub-item {
                    margin-bottom: 0;

                    > span.checkout-line-row {
                        font-size: 1.3rem;
                        padding-top: 10px;
                    }

                    .sub-item-obs {
                        .checkout-line-name li {
                            font-size: 1.1rem;
                        }
                    }

                    .c-combo-options {
                        font-size: 1.3rem;

                        li {
                            font-size: 1.1rem;
                        }
                    }
                }
            }
        }

        .card_column_3 {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .bold_text.price {
                padding-bottom: 0;
                font-size: 1.4rem;
                color: @primary-dark;
            }

            .price_breakdown {
                .price_subtotal {
                    font-size: 1rem;
                }

                .price_desconto {
                    font-size: 1rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckoutItemGom.vue